export default "__VITE_ASSET__DRqzLY26__"